<template>
	<div :class="[prefixCls + '-body']">
		<tree-table-node v-for="(item, i) in stateTree" :key="i"
            :data="item"
            :columns="endColumns"
            :node="getNode(item.nodeKey)"
            :multiple="multiple"
            :show-checkbox="showCheckbox"
            :children-key="childrenKey"
            :level="1"
            :location="location"
            :validations="getValidations(item.nodeKey)"
            visible>
        </tree-table-node>
    </div>
</template>
<script>
	import TreeTableNode from './tree-table-node.vue'

	export default {
		name: "TreeTableBody",

		components: {
			TreeTableNode
		},

        inject: {
            treeRoot: { default: null }
        },

		props: {
            location: {
                type: String,
                default: "middle",
                validator: val => ["left", "middle", "right"].indexOf(val) >= 0
            },
            stateTree: {
            	type: Array,
            	default: () => []
            },
            columns: {
                type: Array,
                default: function() {
                    return []
                }
            },
		},
		
		computed:{    
            prefixCls(){
                return "ivu-tree-table"
            },
            multiple(){
                return this.treeRoot.multiple
            },
            showCheckbox(){
                return this.treeRoot.showCheckbox
            },
            childrenKey(){
                return this.treeRoot.childrenKey
            },
            endColumns(){
                return this.columns.filter(c => c._isEnd)
            },
		},

        methods: {
            getNode(nodeKey){
                return this.treeRoot.flatState[nodeKey]
            },

            getValidations(nodeKey){
                return this.treeRoot.validationMap[nodeKey] || {}
            }
        }

	}
</script>